<h3>Cookies & Privacy</h3>
<p>
  We use our own cookies and third-party cookies for analytical purposes and to
  provide the best website experience possible. For more information, please see
  our
  <a routerLink="/privacy-policy" aria-label="Privacy & Cookies Policy"
    >Privacy and Cookies Policy</a
  >.
</p>

<button matButton="filled" (click)="acceptCookies()">Accept</button>
